import { type AccessRoute, accessRouteChain } from '@nudool/shared';

export function routeRequiresBrandMembership(route: AccessRoute): boolean {
  return accessRouteChain(route).some((entry) => entry.requiresBrandMembership === true);
}
